import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/CreateRubricManual/desktop';
import Mobile from 'pages/CreateRubricManual/mobile';
import { PageContext as CreatePageContext } from 'pages/CreateRubricManual/PageProvider';
import Tablet from 'pages/CreateRubricManual/tablet';
import { PageContext as EditPageContext } from 'pages/EditRubric/PageProvider';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const location = useLocation();
    const { device } = useViewport();

    const PageContext = location.pathname === '/rubrics/new' ? CreatePageContext : EditPageContext;

    const { form, setForm, errors, setErrors, hasClickedSubmit, isUnscored, validateTitle, validateCriteria } =
        useContext(PageContext);

    const props = {
        form,
        setForm,
        errors,
        setErrors,
        hasClickedSubmit,
        isUnscored,
        validateTitle,
        validateCriteria,
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    if (!form) return <Loading />;

    return renderResponsiveLayout(device);
};

export default PageLayout;
